<script lang="ts">
    import { VimeSlider } from "@vime/svelte";
    import { currentTime } from "../stores/player";
    import { currentSegmentIdx } from "../stores/segment";
    import { segments } from "../constants/segments";

    let start: number, duration: number;
    $: {
        start = segments[$currentSegmentIdx].start;
        duration = segments[$currentSegmentIdx].end - start;
    }
    const onValueChange = (event: CustomEvent<number>) => {
        $currentTime = event.detail + start;
    };
</script>

<style>
    p {
        width: 100%;
    }
</style>

<p>
    <VimeSlider
        label="Progress"
        step={0.1}
        max={duration}
        value={$currentTime - start}
        on:vValueChange={onValueChange} />
</p>
